"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayerLogos = exports.getTournamentLogos = exports.selectCompetitorLogoById = exports.selectCompetitorLogoUrl = exports.getCompetitorLogos = void 0;
const slice_1 = require("./slice");
const getLogosProvider = (state) => { var _a; return (_a = state.logosProvider) !== null && _a !== void 0 ? _a : slice_1.initialState; };
const getCompetitorLogos = (state) => getLogosProvider(state).logos.COMPETITOR.entries;
exports.getCompetitorLogos = getCompetitorLogos;
const selectCompetitorLogoUrl = (state, competitorId) => {
    var _a, _b;
    return (_b = (_a = getLogosProvider(state).logos.COMPETITOR.entries[competitorId]) === null || _a === void 0 ? void 0 : _a.logo) === null || _b === void 0 ? void 0 : _b.logoUrl;
};
exports.selectCompetitorLogoUrl = selectCompetitorLogoUrl;
const selectCompetitorLogoById = (state, competotoId) => {
    return (0, exports.getCompetitorLogos)(state)[competotoId];
};
exports.selectCompetitorLogoById = selectCompetitorLogoById;
const getTournamentLogos = (state) => getLogosProvider(state).logos.TOURNAMENT.entries;
exports.getTournamentLogos = getTournamentLogos;
const getPlayerLogos = (state) => getLogosProvider(state).logos.PLAYER.entries;
exports.getPlayerLogos = getPlayerLogos;
//# sourceMappingURL=selectors.js.map